import { isEqual, isObject, isUndefined } from "lodash";

import { TFieldValue, TValidator } from "./formInterfaces";

export const isFieldDirty = (value: TFieldValue, defaultValue: string) => {
  return !isEqual(value, defaultValue);
};

export const validateField = (value: any, validate?: TValidator) => {
  if (isUndefined(validate)) {
    return;
  }

  return validate(value);
};

export const pickValue = (evtOrValue: MouseEvent | TFieldValue) => {
  const isEvent = isObject(evtOrValue) && (evtOrValue as any).target;
  return isEvent ? evtOrValue.target.value : evtOrValue;
};
